export const CEREBRO_LESSON_FORMAT = [
  'Cerebro Lesson Plan',
  'Teaching Guide',
  'Learning Companion',
];
export const footerText = `Copyright © 2023 by Cerebro Solutions, Inc and Lesson Planner. All rights reserved. No part of this publication may be reproduced, distributed, or
transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods, without
the prior written permission of the copyright holder. To request permissions, contact the publisher at support@cerebro.ph.`;
